export const getDateAddedFilterStyle = () => ({
  dateAddedFilterDowndown: {
    padding: 24,
    pointerEvents: 'auto',

    '& .dropdown-title': {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '20px',
    },

    '& .dropdown-value-input': {
      // maxWidth: 140,
      marginTop: 12,
    },

    '& .dropdown-timeframe-choices label': {
      fontSize: 14,
      fontWeight: 400,
      padding: 0,
      marginTop: 8,
    },
  },
});
